/**
 * Convertit une décimale en centimes (entier), sans arrondi.
 * - 2 décimales → pris tel quel
 * - plus de 2 décimales → tronqué
 * - moins de 2 décimales → complété avec des zéros
 * @param {string|number} value
 * @returns {number} centimes
 */
export function decimalToCentsNoRound(value) {
  if (value === null || value === undefined || value === "") return 0;

  let s = typeof value === "number" ? String(value) : String(value);
  s = s.trim().replace(/\s+/g, "");
  s = s.replace(/,/g, "."); // normaliser virgule en point
  const negative = s.startsWith("-");
  s = s.replace(/^[+-]/, "");

  if (s === "" || s === ".") return 0;

  const [intPartRaw, fracPartRaw = ""] = s.split(".");
  const intPart = intPartRaw === "" ? "0" : intPartRaw.replace(/\D/g, "");
  const fracPart = fracPartRaw.replace(/\D/g, "");

  // Tronquer/compléter à 2 chiffres
  const frac2 = (fracPart + "00").slice(0, 2);

  let cents = parseInt(intPart || "0", 10) * 100 + parseInt(frac2 || "0", 10);
  return negative ? -cents : cents;
}


/**
 * Convertit des centimes en chaîne décimale avec deux chiffres après la virgule.
 * Pas d'arrondi, affichage strict "xx.yy".
 * @param {number|bigint} cents
 * @returns {string} ex: "123.45" ou "-0.99"
 */
export function centsToDecimalNoRound(cents) {
  if (cents === null || cents === undefined || isNaN(cents)) return "0.00";

  const negative = Number(cents) < 0;
  const abs = Math.abs(Number(cents));

  const euros = Math.floor(abs / 100);
  const centimes = abs % 100;

  const centimesStr = String(centimes).padStart(2, "0");
  return (negative ? "-" : "") + euros + "." + centimesStr;
}

/**
 * Formate un montant en centimes pour l'affichage en euros avec séparateur de milliers
 * @param {number} cents - montant en centimes
 * @returns {string} ex: "1 234,56 €" ou "123,45 €"
 */
export function formatCurrency(cents) {
  const decimal = centsToDecimalNoRound(cents); // "1234.56"
  const [intPart, fracPart] = decimal.split(".");

  // Ajouter un espace tous les 3 chiffres (de droite à gauche)
  const intFormatted = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, " ");

  return intFormatted + "," + fracPart + " €";
}
